import { useCallback, useRef } from 'react';

/** Déclenche onTrigger après `requiredTaps` appuis rapides (accès admin sur mobile web). */
export default function useSecretTapTrigger(onTrigger, { requiredTaps = 5, windowMs = 2000 } = {}) {
  const tapsRef = useRef([]);

  return useCallback(() => {
    if (!onTrigger) return;
    const now = Date.now();
    tapsRef.current = tapsRef.current.filter((t) => now - t < windowMs);
    tapsRef.current.push(now);
    if (tapsRef.current.length >= requiredTaps) {
      tapsRef.current = [];
      onTrigger();
    }
  }, [onTrigger, requiredTaps, windowMs]);
}
